import request from "@utils/request";

export function getLotDigits() {
    return request({
        url: 'lot-digits',
        method: 'get',
    })
}

export function getAllIncludedLogins(query) {
    return request({
        url: 'logins-by-login-monitor-profile',
        method: 'post',
        data: query
    })
}

export function recheckTask(query) {
    return request({
        url: 'recheck-task',
        method: 'post',
        data: query
    })
}

export function recheckTaskStatus() {
    return request({
        url: 'recheck-task-status',
        method: 'get',
    })
}

export function fetchRecheckTaskResult(query) {
    return request({
        url: 'recheck-task-result',
        method: 'post',
        data: query
    })
}

export function fetchRankingData(query) {
    return request({
        url: 'ranking',
        method: 'post',
        data: query
    })
}